export default "__VITE_ASSET__BgGyjKec__"